import { Template, Unit } from 'ballerina-core'
import React, { ReactNode } from 'react'
import { NetworkStatusState } from './networkStatus.state'

export type NetworkStatusView = {
  NetworkStatus: (_: { online: boolean; onOffline: () => void; onOnline: () => void }) => ReactNode
}

export const NetworkStatusTemplate = Template.Default<Unit, NetworkStatusState, Unit, NetworkStatusView>(
  ({ context, setState, view }) => (
    <view.NetworkStatus
      online={context === 'online'}
      onOnline={() => setState(() => 'online')}
      onOffline={() => setState(() => 'offline')}
    />
  )
)
